import { useQuery } from '@tanstack/react-query'

import { http } from '@/lib/http'

import { CaptchaSchema } from '../schemas/auth'
import { ResultSchema } from '../schemas/common'
import { UserSchema } from '../schemas/user'

export const fetchCaptcha = async () => {
  const json = await http.get('auth/captcha').json()
  const captcha = ResultSchema(CaptchaSchema).parse(json).data
  if (!captcha) throw new Error('Empty captcha response')
  return captcha
}

export const fetchCurrentUser = async () => {
  const json = await http.get('users/me').json()
  const user = ResultSchema(UserSchema).parse(json).data
  if (!user) throw new Error('Empty current user response')
  return user
}

export const useCaptchaQuery = () =>
  useQuery({
    queryKey: ['auth', 'captcha'],
    queryFn: fetchCaptcha,
    staleTime: 0,
    gcTime: 0,
  })

export const useMeQuery = (enabled = true) =>
  useQuery({
    queryKey: ['auth', 'me'],
    queryFn: fetchCurrentUser,
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
  })
